// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"current-therapy-information-collapsed-module__tabRow___1f4Of"};